// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"LoadProject_dropzone__269Or","reject":"LoadProject_reject__3ilyi","accept":"LoadProject_accept__2nDU9","browse-button":"LoadProject_browse-button__3Tvtx"};